module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-up-36d5e6a4f88705b28b2a5c639993bb4d.svg";